import type { MeContext, MeContextWire } from './types';

// Snake_case GET /v1/me wire payload → FE camelCase contract.
export function mapMeContext(wire: MeContextWire): MeContext {
  return {
    user: {
      id: wire.user.id,
      email: wire.user.email,
      name: wire.user.name ?? '',
    },
    isSuperAdmin: wire.is_super_admin,
    grants: wire.grants.map((grant) => ({
      role: grant.role,
      scopeType: grant.scope_type,
      scopeId: grant.scope_id,
    })),
    organization: {
      id: wire.organization.id,
      name: wire.organization.name,
      defaultPortfolioId: wire.organization.default_portfolio_id,
      portfolioCount: wire.organization.portfolio_count,
      workspaceCount: wire.organization.workspace_count,
      portfolios: wire.organization.portfolios.map((portfolio) => ({
        id: portfolio.id,
        name: portfolio.name,
        defaultWorkspaceId: portfolio.default_workspace_id,
        workspaces: portfolio.workspaces.map((workspace) => ({
          id: workspace.id,
          slug: workspace.slug,
          name: workspace.name,
          // Wire workspace nodes omit portfolio_id — attach from parent.
          portfolioId: portfolio.id,
        })),
      })),
    },
  };
}
